import { React, useState } from 'react';
import { RangeStepInput } from 'react-range-step-input';
import Modal from '../Modal';
import './index.scss';

const Slider = ({ radius, show, setShow, onChange }) => {
  const [selectedRadius, setSelectedRadius] = useState(radius);

  if (!show) {
    return null;
  }

  const onChangeSlider = (event) => {
    setSelectedRadius(parseInt(event.target.value));
  };

  const onClick = (event) => {
    event.preventDefault();

    onChange(selectedRadius);
    setShow(false);
  };

  const onClickClose = (event) => {
    event.preventDefault();

    setShow(false);
  };

  return (
    <Modal title='Selecciona el grosor' fast={true}>
      <div className='slider-container'>
        <i className='decoration decoration--small'></i>
        <div className='slider'>
          <RangeStepInput value={selectedRadius} min={1} max={20} onChange={onChangeSlider} />
        </div>
        <i className='decoration decoration--big'></i>
      </div>
      <button className='button button--tool' onClick={onClick}>
        Escoger
      </button>
      <button className='button button--tool' onClick={onClickClose}>
        Cancelar
      </button>
    </Modal>
  );
};

export default Slider;
